<template>
  <div>
    <div class="spl-edit-template__step spl-book-additional-info">
      <div class="row">
        <!-- *********************** Delivery Note  *********************************** -->
        <div class="col12">
          <form-label>Delivery Information</form-label>
          <form-textarea v-model="bookingData.book_parcel_model.Delivery_Information" placeholder="Please don't fill any personal or subjective information in this field" />
        </div>
      </div>
    </div>
    <!-- *********************** Save footer  *********************************** -->
    <parcel-book-footer
      :booking-type="bookingType"
      :is-booking="isBooking"
      :is-forward="bookingData.book_parcel_model.Is_Forward"
      :booking-data="bookingData"
      @cancelClicked="onCancel"
      @saveClicked="onSave" />
  </div>
</template>

<script>
export default {
  name: 'BookingAdditionalInformations',
  props: ['bookingData', 'nextStepLabel', 'bookingType', 'isBooking'],
  data () {
    return {
      saveClicked: false
    }
  },
  methods: {
    onSave (saveOptions) {
      this.saveClicked = true
      this.bookingData.saveOptions = saveOptions
      this.$emit('save', this.bookingData)
    },
    onCancel () {
      this.$emit('cancel')
    },
    reset () {
      this.saveClicked = false
    },
    isValid () {
      return this.saveClicked
    }
  }
}
</script>

<style lang="scss">
@import '../../variables.scss';
@include mobile() {
  .spl-book-additional-info {
    & .spl-textarea {
      height: 150px;
    }
  }
}
</style>
